import mockLogoString from "../../utils/mock-logo-string.mjs";

export default {
    "guide.name": "Dialogue Theme Runner",

    /**
     * ============================
     * GENERAL
     * ============================
     */
    "cart.add": "Add To Cart",
    "cart.remove": "Remove From Cart",

    "nav.prev": "Go Back",
    "nav.next": "Next",

    "branchMenu.employeeInfoHeader": "Employee Details",
    "branchMenu.logout": "Logout",

    "contactOnExit.title": "Let's save your conversation",
    "contactOnExit.text":
        "Enter your email below and submit to send your conversation URI and ID in your inbox so you can reference it later.",
    "contactOnExitToast.info.title": "Conversation Details Sent",
    "contactOnExitToast.info.message":
        "Your conversation information has been sent to your email",

    "contactFormPage.title": "Complete The Conversation",
    "contactFormPage.text":
        "Complete the form below and submit to send your result to a representative and complete the conversation. " +
        "We will also send the results to your email (you can opt-out if preferred)",
    "contactFormPageToast.success.title": "Contact Form Completed",
    "contactFormPageToast.success.message":
        "Your information has been submitted, thank you.",

    "contactMeForm.formInput.firstName": "First Name:",
    "formInput.firstName.placeholder": "Enter first name",
    "contactMeForm.formInput.lastName": "Last Name:",
    "formInput.lastName.placeholder": "Enter last name",
    "contactMeForm.formInput.email": "Email:",
    "formInput.email.placeholder": "hello@ignitesales.com",
    "contactMeForm.formInput.phone": "Phone Number:",
    "formInput.phone.placeholder": "(254) 548-1550",

    "error.title": "Errors",
    "error.question.required": "Must be answered",
    "error.question.between": "Value must be between {0} and {1}",
    "error.questionGroup.required": "You must answer a question",
    "error.questionGroup.between": "Total value must be between {0} and {1}",
    "error.questionGroup.equal": "Total value must equal to {0}",

    "landing.title": "Welcome To Ignite Dialogue",
    "landing.message":
        "Ready to find the best products for your financial needs? Let's get started on finding the perfect account for you.",
    "landing.readyToStart": "Let's Go",
    "landing.button": "Let's Go",

    loadingPage: "Loading...",

    logo: mockLogoString,

    "summary.subtitle":
        "Congratulations, we were able to find your matching products.",
    "summary.title": "Product Recommendations",
    "summary.schedule": "Schedule an Appointment",
    "summary.subtext":
        'Review your products below. Click the "Finish Up" button to save your results and complete the process.',
    "summary.completeBtn": "Finish Up",
    "summary.previousPageBtn": "Return to Conversation",
    "summary.shareBtn": "Share Results",
    "summary.viewAnswers": "View Answers",

    "socialActionBar.title": "Share",
    "socialActionBar.textMessage": "SMS",
    "socialActionBar.email": "Email",
    "socialActionBar.print": "Print",

    "socialActionHeader.title":
        "Take action on your products and share your results!",

    pleaseSelect: "Please Select",

    "product.seeDetails": "More Details",
    "product.seeDetails.header": "Product Details",
    "product.features.title": "Features:",
    "product.disclosures.title": "Disclosures:",
    "product.collapsible.open.title": "Features and Disclosures",
    "product.collapsible.closed.title": "Features and Disclosures",
    "product.seeMore": "See More",

    "products.disclosures.title": "Disclosures",
    "products.features.title": "Features",

    "answers.title": "Your Conversation Answers",
    "answers.subtext":
        "Review your questions and answers below from your conversation.",

    "footer.copyright":
        "Powered By Ignite Dialogue | All Rights Reserved | {year}",

    "themeTool.subtitle": "Ignite Dialogue",
    "themeTool.title": "Theme Runner Tool",
    "themeTool.propertiesEditor": "Edit Theme Properties",
    "themeRunnerColorEditor.helpText":
        "Enter hex colors below and submit to change theme colors.",

    "themeRunnerColorEditor.formInput.primaryColor": "Primary Color:",
    "themeRunnerColorEditor.formInput.primaryColor.error.required":
        "Please enter a valid color in HEX format",
    "themeRunnerColorEditor.formInput.primaryColor.placeholder": "#3b3e47",

    "themeRunnerColorEditor.formInput.secondaryColor": "Secondary Color:",
    "themeRunnerColorEditor.formInput.secondaryColor.error.required":
        "Please enter a valid color in HEX format",
    "themeRunnerColorEditor.formInput.secondaryColor.placeholder": "#0c5c5c",

    "themeRunnerFdicEditor.formInput.isFdicMember": "FDIC Member",
    "themeRunnerEhlEditor.formInput.isEhlMember": "EHL Member",
    "themeRunnerHideActionsEditor.formInput.hideActions":
        "Hide Products Actions",

    "themeRunnerColorsUpdated.success.title": "Colors Updated",
    "themeRunnerColorsUpdated.success.message":
        "Theme Runner colors have been saved",
    "themeRunnerColorsUpdated.error.title": "Invalid Color(s)",
    "themeRunnerColorsUpdated.error.message":
        "One or more of your color values is not in HEX format",

    "themeRunnerFdicUpdated.success.title": "FDIC Updated",
    "themeRunnerFdicUpdated.success.message":
        "Theme Runner FDIC has been saved",
    "themeRunnerFdicUpdated.error.title": "Invalid FDIC",
    "themeRunnerFdicUpdated.error.message":
        "Please check if client is FDIC member or not",

    "themeConfigurationUpdated.success.title": "Theme Configuration Updated",
    "themeConfigurationUpdated.success.message":
        "Theme Runner configurations have been saved",
    "themeConfigurationUpdated.error.title": "Invalid Configurations",
    "themeConfigurationUpdated.error.message":
        "Please check for any invalid theme configuration",

    /**
     * ============================
     * QUESTIONS
     * ============================
     */

    /**
     * ============================
     * PRODUCTS
     * ============================
     */
    "1000.button.1.text": "Apply",
    "1000.button.1.url": "https://www.ignitesales.com",
    "1000.button.1.id": "24a61b8f-2f8f-44bf-8ade-ce9c3a915b6e",

    "1001.button.1.text": "Enroll",
    "1001.button.1.url": "https://www.ignitesales.com",
    "1001.button.1.id": "690de4b3-852e-4b4f-a6d3-8fe633c68cc6",

    "1002.button.1.text": "Open",
    "1002.button.1.url": "https://www.ignitesales.com",
    "1002.button.1.id": "366420b6-a7fe-4d49-b965-a6db49d1ffa4",

    "1003.button.1.text": "Product Details",
    "1003.button.1.url": "https://www.ignitesales.com",
    "1003.button.1.id": "1d8e3322-1334-4fc0-b12b-30c981b70fa0",

    "1004.button.1.text": "Contact Us",
    "1004.button.1.url": "https://www.ignitesales.com",
    "1004.button.1.id": "cb8b34f3-5d1f-4b49-8581-7aec67f5116d",
};
